<div class="footer">
    <span>CN-BIM © {{year}}</span>
    &nbsp;
    <a href="http://www.enerbim.com" target="_blank">ENERBIM</a>
    &nbsp;
    <a href="https://digiliance.fr/" target="_blank">Digiliance</a>
    &nbsp;
    <a [routerLink]="['/legal']">Infos légales</a>

    <a class="version" href="javascript:void(0)" (click)="showAppInfo()">v{{version}}</a>
</div>
